export default __webpack_public_path__ + "static/media/avi-packer.f383a245.png";